import { MODEL_ID, PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

/**
 * Inverse of parseTripo3dMeshSimplificationDefaultData. Builds an openedModel-
 * shaped payload from the current remeshSettings so the just-submitted run can
 * be reopened without an extra API round-trip.
 *
 * @param {Object} state - ThreeDStudio store state (getState())
 * @param {string|number} id - Run id from the generation API response
 * @returns {Object} - openedModel payload accepted by parseTripo3dMeshSimplificationDefaultData
 */
export const buildTripo3dMeshSimplificationDefaultFromState = (state, id) => {
  const {
    faceLevel,
    polygonType,
  } = state.remeshSettings || {}

  return {
    id,
    providerKey: PROVIDER.TRIPO3D,
    providerModelId: MODEL_ID.TRIPO3D_MESH_SIMPLIFICATION_DEFAULT,
    providerRunAttributes: {
      ...(faceLevel != null && { faceLevel }),
      ...(polygonType != null && { polygonType }),
    },
  }
}
